import React from "react";
import GlobalDialog from "../../../../mui/Dialogue/GlobalDialog";
import { Button } from "@mui/material";
import { TrainerDetails } from "./TrainerDetails";

export const TrainerProfile = () => {
    const [open, setOpen] = React.useState(false);
    return (
        <div>
            <GlobalDialog
                title="Trainer Profile"
                fullWidth
                maxWidth={"lg"}
                open={open}
                setOpen={setOpen}
                closeButton={true}
                popupButton={
                    <Button variant="outlined" onClick={() => setOpen(true)}>
                        View
                    </Button>
                }
                content={<TrainerDetails />}
            />
        </div>
    );
};
